import React, { useState } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { ButtonLink } from '@daedalus/atlas/ButtonLink';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { defaultCurrencyCode } from '@daedalus/core/src/localization/business/currency';
import { getCancellationDeadline, getRefundType } from '@daedalus/core/src/offer/business/cancellationPenalties';
import { getLinkByType } from '@daedalus/core/src/offer/business/getLinkByType';
import { ActionLinkTypes } from '@daedalus/core/src/offer/types/actionLink';
import { CancellationLabel } from '@daedalus/shared/src/booking/CancellationLabel';
import { CancellationPenaltiesPopUp } from '@daedalus/shared/src/booking/OfferDetails/CancellationPenaltiesPopUp';
import { getRoomVariant } from '../RoomVariant/getRoomVariant/getRoomVariant';
import { SplitBookingFooterVariant } from '../RoomVariant/SplitBookingFooterVariant';
import { RoomCardVariants } from '../RoomVariant/types';
import { OfferCTA } from './OfferCTA';
import { RoomsOfferPrice } from './RoomsOfferPrice';
import type { OfferPrice } from '@daedalus/core/src/offer/types/offer';
import type { RoomWithoutOffers, SplitBookingDates } from '@daedalus/core/src/room/types/room';
import type { CancellationPenalties, RoomLinks } from '@findhotel/sapi';
const PriceAndCTAWrapper = /*#__PURE__*/styled('div')({
  name: "PriceAndCTAWrapper",
  class: "phr7rc3",
  propsAsIs: false
});
interface Props {
  hotelId: string;
  hotelCurrencyCode: string;
  chargeableCurrencyCode: string;
  hotelTimeZone: string;
  cancellationPenalties: CancellationPenalties[];
  totalPrice: number;
  prices: OfferPrice[];
  splitBookingRooms: RoomWithoutOffers[];
  splitBookingDates: SplitBookingDates;
  bundleId: string;
  links: RoomLinks[];
  cug: string[];
  providerCode: string;
  providerRateType: string;
  isSelected: boolean;
  isCheapest: boolean;
}
export const SplitBookingCardFooter = ({
  hotelId,
  hotelCurrencyCode,
  chargeableCurrencyCode,
  cancellationPenalties,
  hotelTimeZone,
  prices,
  totalPrice,
  splitBookingRooms,
  splitBookingDates,
  bundleId,
  links,
  cug,
  providerCode,
  providerRateType,
  isSelected,
  isCheapest
}: Props) => {
  const {
    isMobile
  } = useDeviceLayout();
  const [isCancellationPenaltiesDetailsOpen, setIsCancellationPenaltiesDetailsOpen] = useState(false);
  const onCancellationLabelClick = () => {
    setIsCancellationPenaltiesDetailsOpen(true);
  };
  const variant = getRoomVariant({
    isSelected,
    isCheapest
  });
  const cancellationPenaltyAvailable = Boolean(cancellationPenalties);
  const cancellationDeadline = getCancellationDeadline(cancellationPenalties);
  const refundType = getRefundType(cancellationPenalties);
  return <>
      <ContentWrapper paddingX={isMobile ? 's500' : 's600'} paddingTop="s000" paddingBottom="s500">
        <SplitBookingFooterVariant variant={isMobile || !cancellationPenaltyAvailable ? RoomCardVariants.None : variant}>
          <Flex.Row justifyContent="space-between" alignItems="flex-start">
            {cancellationPenaltyAvailable ? <ContentWrapper paddingTop="s250">
                <ButtonLink target="_blank" onClick={onCancellationLabelClick} rel="noreferrer" size="sm" isCompact variant="info" isDotted dataId="splitBooking.cancellationLabel">
                  <CancellationLabel refundType={refundType} freeCancellationDeadline={cancellationDeadline} variant="roomDetails" hideFreeCancellationDeadlineDate />
                </ButtonLink>
              </ContentWrapper> : <div />}
            <PriceAndCTAWrapper className={cx(isMobile && '__isMobile')}>
              <RoomsOfferPrice hotelId={hotelId} prices={prices} splitBookingDates={splitBookingDates} splitBookingRooms={splitBookingRooms} propertyCurrencyCode={hotelCurrencyCode} />
              <Flex.Row>
                <OfferCTA rooms={splitBookingRooms} bundleId={bundleId} sbCheckoutUrl={getLinkByType(links, ActionLinkTypes.CHECKOUT) || ''} cug={cug} providerCode={providerCode} providerRateType={providerRateType} />
              </Flex.Row>
            </PriceAndCTAWrapper>
          </Flex.Row>
        </SplitBookingFooterVariant>
      </ContentWrapper>
      {cancellationPenaltyAvailable && <CancellationPenaltiesPopUp cancellationPenalties={cancellationPenalties} hotelTimeZone={hotelTimeZone} totalPrice={totalPrice} currencyCode={chargeableCurrencyCode || defaultCurrencyCode} setIsCancellationPenaltiesDetailsOpen={setIsCancellationPenaltiesDetailsOpen} isCancellationPenaltiesDetailsOpen={isCancellationPenaltiesDetailsOpen} prefersReducedMotion isSplitBookingDeal />}
    </>;
};

require("./SplitBookingCardFooter.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SplitBookingCardFooter.tsx");